import React from "react";
import clsx from "clsx";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import CircularProgress from "@mui/material/CircularProgress";
import Button, { ButtonProps } from "@mui/material/Button";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      position: "relative",
    },
    buttonDisabled: {
      backgroundColor: `${theme.palette.grey[400]}!important`,
      borderColor: `${theme.palette.grey[400]}!important`,
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -10,
      marginLeft: -12,
    },
    buttonColor: {},
  }),
);

interface Props {
  loading: boolean;
  children?: React.ReactNode;
  submitType?: boolean;
}

export function ProgressButton(props: Props & ButtonProps) {
  const classes = useStyles();

  const { loading, children, submitType, ...rest } = props;

  const buttonClassname = clsx({
    [classes.buttonDisabled]: loading,
  });

  return (
    <span className={classes.root}>
      <Button
        variant="contained"
        type={submitType ? "submit" : undefined}
        color="primary"
        className={buttonClassname}
        disabled={props.loading}
        {...rest}
      >
        {children}
      </Button>
      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </span>
  );
}
